module.exports = __webpack_public_path__ + "img/ic_warning_used.svg";